import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, FormControl, FormArray } from '@angular/forms';

function setLowerCase(value: string): string {
    return value ? value.toLowerCase() : value;
}

function onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
}

@Injectable()
export class ValidateTagValidator {
    static validate(tags: string[]): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (control.value && tags.includes(setLowerCase(control.value)) && control.dirty) {
                return { validTag: true };
            }

            return null;
        };
    }

    static validateForm(): ValidatorFn {
        return (form: AbstractControl): { [key: string]: boolean } | null => {
            const tagOnFormControl = form.get('tag') as FormControl;
            const multipleOutputArray = form.get('multipleOutputs') as FormArray;

            setControls(false);

            if (multipleOutputArray) {
                const multipleOutputTags = multipleOutputArray.value;

                const filtered = multipleOutputTags.filter((o) => 
                    setLowerCase(o.tag) === setLowerCase(tagOnFormControl.value))

                const unique = multipleOutputTags.map(t => setLowerCase(t.tag)).filter( onlyUnique );

                if ((multipleOutputTags.length && filtered.length) || (unique.length !== multipleOutputTags.length)) {
                    setControls(true);
                    return { validTag: true };
                }
            }

            return null;

            function setControls(value: boolean) {
                tagOnFormControl.setErrors(value ? { validTag: true } : null);

                if (!value) {
                    tagOnFormControl.updateValueAndValidity({ onlySelf: true});
                }

                if (multipleOutputArray) {
                    multipleOutputArray.value.map((t, $i) => {
                        const tag = multipleOutputArray.at($i).get('tag') as FormControl;
                        tag.setErrors(value ? { validTag: true } : null)

                        if (!value) {
                            tag.updateValueAndValidity({onlySelf: true});
                        }
                    });
                }
            }
        };
    }
}
